
import Placeholder from '../components/Placeholder';

function JobSitesPlaceholder() {
  const title = 'Job Sites';
  const description = 'This section provides a centralized view of active and historical projects across the business unit. It is designed to help users quickly locate projects, understand ongoing operations, and monitor project performance.';
  const features = [
    'Centralized list of future, active, and completed projects',
    'Advanced filtering by region, technique, status, and location',
    'Interactive mapping and project location visibility',
    'Daily and total production performance monitoring',
    'Sorting of projects based on operational performance',
    'Historical performance tracking throughout the life of a project',
    'Quick access to project details and supporting information',
  ];
  const benefits = 'Forge will provide both daily and overall project performance indicators, allowing managers to quickly identify projects that may require additional attention and prioritize their efforts accordingly.\nBy centralizing project information, teams can more easily locate, monitor, and support projects across the organization.';

  return (
    <Placeholder
      title={title}
      description={description}
      features={features}
      benefits={benefits}
    />
  )
}

export default JobSitesPlaceholder;